import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  InputGroup
} from "reactstrap";
import * as rxjs from "rxjs";
import { debounceTime } from "rxjs/operators";
import { isIE } from 'react-device-detect';
import store from "REDUX/store";
import i18n from "CONFIG/i18n";

import { getMessage, changeLanguage, replaceTranslationDataToResources } from "CONFIG/i18n";
import { systemAnnouncementAction, organisationAction } from "CONFIG/ActionFactory";
import { LANGUAGES, APP_CONFIG, DEFAULT_LANGUAGE, NAME_NG_REGEX, LANGUAGE, SPEED_TEST_RESULT } from "UTILS/Constants";
import { getAnnouncementUser, checkEmpty, getURLParameter, isAnnouncementBlank, removeTrailingSlash } from "UTILS/Utility";

import "./SplashScreen.less";

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: this.props.selectedLanguage,
      userName: "",
      errorMessage:""
    };
    this.startSessionObserver = new rxjs.Subject();
  }

  componentDidMount() {
    // set if present in url
    let userName = getURLParameter("name");
    if (!checkEmpty(userName)){
      userName = userName.substr(0, 50);
      this.setState({ userName: userName});
    }
    // get active announcements
    systemAnnouncementAction.getAllActiveAnnouncementsAction().then(
      (response) => {
        this.setState({
          activeAnnouncements: response.data
        })
      },
      error => {
        console.error(error);
      }
    )
    this.startSessionObserver.pipe(debounceTime(500)).subscribe(fn => {
      if (typeof fn === "function") fn();
    });

    this.updateTenantLanguage();
    changeLanguage();
  }

  handleLanguageChange = event => {
    let selectedLanguage = event.target.value;
    changeLanguage(selectedLanguage);
    this.setState({ selectedLanguage: selectedLanguage });
    this.props.handleChangeLanguage(selectedLanguage);
  };

  handleStartClick = event => {
    if (this.props.isSpeedTestRunning) {
      return;
    }
    const user = this.state.userName.trim();
    if (!checkEmpty(user) && user.match(NAME_NG_REGEX)) {
      this.setState({ errorMessage: "NAME_ERROR_MSG" });
      this.disableStartBtn(false);
      return;
    }

    this.disableStartBtn(true);
    this.props.updateProfile({
      first_name: this.state.userName.trim(),
      last_name: ""
    });
    this.props.handleStartClick(this.errorCallBack, this.state.userName.trim());
  };

  errorCallBack = (errorMessage) =>{
    if(errorMessage){
      this.setState({ errorMessage: errorMessage});
    }
    this.disableStartBtn(false);
  }

  componentDidUpdate(prevProp) {
    if (this.props.selectedLanguage !== prevProp.selectedLanguage) {
      this.setState({ selectedLanguage: this.props.selectedLanguage });
    }
    if(this.props.errorMessage !== prevProp.errorMessage && this.props.errorMessage){
      this.setState({errorMessage: this.props.errorMessage})
    }
  }

  handleInputChange = event => {
    this.setState({ errorMessage: "" });
    this.setState({ [event.target.name]: event.target.value });
  };

  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleStartClick();
    }
  };

  disableStartBtn = (value) => {
    let startBtn = document.getElementById("startQRSessionBtn");
    if(startBtn)
      startBtn.disabled = value;
  }

  componentWillUnmount() {
    this.disableStartBtn(false);
  }

  updateTenantLanguage = () => {
    if (!this.props.gottenWording && !this.props.isWordingGotten) {
      if ("/" + (removeTrailingSlash(window.location.pathname).split("/"))[1] === store.getState().UserReducer.uriIdentifier) {
        this.getOrgWording();
      }
    } else if (this.props.gottenWording && this.props.isWordingGotten) {
      replaceTranslationDataToResources(this.props.setLanguageAction);
    }
  }

  getOrgWording = () => {
    organisationAction.getOrgWordingUrlAction('', (removeTrailingSlash(window.location.pathname).split("/"))[1]).then(
      response_data => {
        replaceTranslationDataToResources(this.props.setLanguageAction);
      },error => {
      }
    );
  };

  renderSpeedTest = () => {
    if (this.props.isSpeedTestRunning) {
      if (this.props.speedTestRemainingTime > 0) {
        return (
          <div className="speedTest">
            {`${getMessage("SPEED_TEST_RUNNING")} ${getMessage("REMAINING_TIME", {sec: this.props.speedTestRemainingTime})}`}
          </div>
        );
      } else {
        return (
          <div className="speedTest">
            {getMessage("SPEED_TEST_PLEASE_WAIT")}
          </div>
        );
      }
    } else {
      let resultMessage;
      if (this.props.ownSpeedTestError) {
        // timeout
        resultMessage = getMessage(
          "SPEED_TEST_TIME_OUT_GUEST",
          { speedTestTimeoutSeconds: window._env_.SPEED_TEST_TIMEOUT_MSEC / 1000 }
        );
      } else if (this.props.speedTestResult === -1) {
        // speed test error
        resultMessage = getMessage("SPEED_TEST_FAILURE_MESSAGE_GUEST");
      } else {
        resultMessage = this.props.speedTestResult !== undefined && 
        getMessage(Object.keys(SPEED_TEST_RESULT).find((key) => {
          return (SPEED_TEST_RESULT[key] === this.props.speedTestResult);
        }));
      }
      return (
        <div className="speedTest">
          <div>
            {getMessage("CLICK_PROCEED_BUTTON")}
          </div>
          <div>
            {`${getMessage("CONNECTION_STATUS")}: ${resultMessage}`}
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="splashScreenMain flexDirectionColumn">
        {/* {this.props.logoUrl ? ( */}
        <div className="logoImage">
          {this.props.logoUrl ? (
            this.props.isLogoPresent === false ? <img src={this.props.logoUrl} />: <img src={this.props.logoUrl}/>
          ) : (
            this.props.isLogoPresent ? getMessage("LOADING") : null
          )}
        </div>
        <div>
          {this.state.activeAnnouncements && isAnnouncementBlank(this.state.activeAnnouncements, getMessage("USER_QRCODE_SCREEN")) && 
            <marquee>
              <label className="announcementLabel mt-2">
                {getAnnouncementUser(this.state.activeAnnouncements, window.location.href)}
              </label>
            </marquee>
          }
        </div>
        <div className="logoImage pt-4">
          <InputGroup>
            <Input
              type="text"
              onChange={this.handleInputChange}
              name="userName"
              placeholder={getMessage("ENTER_YOUR_NAME")}
              aria-label="Enter name"
              className="formControlName"
              value={this.state.userName}
              maxLength={50}
              onKeyPress={this.enterPressed}
              autoFocus={!isIE}
            />
          </InputGroup>
          <Row className="justifyContentFlexCenter mr-0 pt-3">
            {Object.keys(LANGUAGES).map(lang => (
              <FormGroup className="languageRadio" check key={lang}>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    value={lang}
                    onChange={this.handleLanguageChange}
                    checked={
                      this.state.selectedLanguage
                        ? this.state.selectedLanguage === lang
                        : (lang === DEFAULT_LANGUAGE)
                    }
                  />{" "}
                  {LANGUAGES[lang]}
                </Label>
              </FormGroup>
            ))}
          </Row>
          {this.renderSpeedTest()}
          <div className="pt-4">
            <Button
              id="startQRSessionBtn"
              className="customBtn btnSplash"
              disabled={this.props.isSpeedTestRunning}
              onClick={() => {
                let startBtn = document.getElementById("startQRSessionBtn");
                if(startBtn)
                  startBtn.disabled = true; 
                this.startSessionObserver.next(this.handleStartClick)
              }}
            >
              {getMessage("START")}
            </Button>
          </div>
        </div>
        <div>
          <a href={window._env_.HELP_URL} target='_blank' className="helpLink">{getMessage("ONLINE_HELP")}</a>
        </div>
        <div className="errors pt-4">
          {getMessage(this.state.errorMessage)}
        </div>
        {/* // ) : (
        //   getMessage("LOADING")
        // )} */}
      </div>
    );
  }
}

export default SplashScreen;
